/**
 * Represents a single resize handle
 */
export default class ResizeHandleMarker {
    constructor(key, oppositeKey, element, multiplierX = null, multiplierY = null) {
        this.key = key;
        this.oppositeKey = oppositeKey;
        this.element = element;
        this.multiplierX = multiplierX;
        this.multiplierY = multiplierY;
    }
}
